import styled from "styled-components";
import {JackpotBetWinDialogLogoDefaultBox} from "./jackpot-bet-win-dialog-logo.default.box";

export const JackpotBetWinDialogCasino777Box = styled(JackpotBetWinDialogLogoDefaultBox)`
    height: 10rem;
    width: 19rem;  
    background-repeat: no-repeat;
    top: -3rem;

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: 25rem;  
        height: 20rem;
    }
`;